/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ParcelSubjectForContractDetailDto { 
    ownershipId?: number;
    parcelId?: number;
    podilCitatel?: number;
    podilJmenovatel?: number;
    portion?: number;
    subjectEndDate?: string;
    subjectId?: number;
    typravKod?: string;
}

